import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const key = (c) => `${c.name || ""}|${c.phone || ""}|${c.email || ""}`;

export const PointOfContactField = ({ customer, value, onChange }) => {
  const contacts = (customer?.contacts || []).filter((c) => c.name || c.phone || c.email);
  const primary = contacts.find((c) => c.is_primary) || contacts[0];
  const hasOwn = !!(value.contact_name || value.contact_phone || value.contact_email);
  const matched = hasOwn ? contacts.find((c) => key(c) === key({ name: value.contact_name, phone: value.contact_phone, email: value.contact_email })) : null;
  const selected = !hasOwn ? "primary" : matched ? `c:${key(matched)}` : "other";
  const pick = (v) => {
    if (v === "primary") return onChange({ contact_name: null, contact_phone: null, contact_email: null });
    if (v === "other") return onChange({ contact_name: value.contact_name || " ", contact_phone: value.contact_phone || "", contact_email: value.contact_email || "" });
    const c = contacts.find((x) => `c:${key(x)}` === v);
    if (c) onChange({ contact_name: c.name || "", contact_phone: c.phone || "", contact_email: c.email || "" });
  };
  return (
    <div data-testid="poc-field">
      <Label>Point of contact</Label>
      <Select value={selected} onValueChange={pick} disabled={!customer}>
        <SelectTrigger data-testid="poc-select"><SelectValue placeholder="Select a customer first" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="primary" data-testid="poc-option-primary">{primary ? `Customer's primary contact (${primary.name || primary.phone || primary.email})` : "Customer's primary contact (none on file)"}</SelectItem>
          {contacts.map((c) => <SelectItem key={key(c)} value={`c:${key(c)}`} data-testid="poc-option-contact">{c.name || "Unnamed"}{c.title ? ` - ${c.title}` : ""}{c.phone ? ` · ${c.phone}` : ""}</SelectItem>)}
          <SelectItem value="other" data-testid="poc-option-other">Someone else for this appointment…</SelectItem>
        </SelectContent>
      </Select>
      {selected === "other" && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-2" data-testid="poc-custom-fields">
          <Input placeholder="Name" value={(value.contact_name || "").trimStart()} onChange={(e) => onChange({ ...value, contact_name: e.target.value || " " })} data-testid="poc-name-input" />
          <Input placeholder="Phone" value={value.contact_phone || ""} onChange={(e) => onChange({ ...value, contact_phone: e.target.value })} data-testid="poc-phone-input" />
          <Input placeholder="Email" type="email" value={value.contact_email || ""} onChange={(e) => onChange({ ...value, contact_email: e.target.value })} data-testid="poc-email-input" />
        </div>
      )}
      <p className="text-xs text-slate-500 mt-1">Shown to the technician in the assignment email. {!primary && selected === "primary" && "No contact on file - the email will say \"Not specified\"."}</p>
    </div>
  );
};
